
import { Inject, Pipe, PipeTransform } from '@angular/core';
import { FormatProviderService }       from '../format-provider.service';
import { FormatRegisteredItem }        from '@cs/core';

@Pipe({standalone: false, name: 'format', pure: true})
export class FormatPipe implements PipeTransform {

	constructor(@Inject(FormatProviderService) private formatProviderService: FormatProviderService) {

	}

	transform(value: any = null, formatString: string = null): any {
		// Guard against empty or missing values and formats to avoid downstream formatter errors
		if (value === '' || value === null || value === undefined) return value;
		if (formatString === null || formatString === undefined) return value;
		return this.formatProviderService.format(value, new FormatRegisteredItem(null, formatString));
	}


}
